module.exports = __webpack_public_path__ + "img/shuziren.fbaa5584.png";